const getContentType = (type: string) => {
  switch (type) {
    case 'mp4':
    case 'webm':
      return `video/${type}`;
    case 'mpd':
    case 'dash':
      return 'application/dash+xml';
    case 'm3u8':
    case 'hls':
      return 'application/x-mpegURL';
    case 'aac':
      return 'audio/x-aac';
    case 'mp3':
      return 'audio/mpeg';
    default:
      return type;
  }
};

const createMediaUrl = (file: string) => {
  const element = document.createElement('a');
  element.href = file;

  return element.href;
};

const createGenericMediaMetadata = (playlistItem: jwplayer.PlaylistItem) => {
  const { title, description, image } = playlistItem;

  const metadata = new chrome.cast.media.GenericMediaMetadata();

  if (title) {
    metadata.title = title;
  }
  if (description) {
    metadata.subtitle = description;
  }

  if (image) {
    metadata.images = [
      {
        url: createMediaUrl(image),
        height: null,
        width: null,
      },
    ];
  }

  return metadata;
};

const createMediaTrack = (
  playlistItemTrack: jwplayer.PlaylistItemTrack,
  index: number
) => {
  const { file, label, kind } = playlistItemTrack;

  const trackId = index + 1;

  const track = new chrome.cast.media.Track(
    trackId,
    chrome.cast.media.TrackType.TEXT
  );

  track.trackContentId = file!;
  track.trackContentType = 'text/vtt';
  track.name = label || String(trackId);

  const subtype = kind.toUpperCase() as chrome.cast.media.TextTrackType;

  track.subtype = subtype;

  if (
    subtype !== chrome.cast.media.TextTrackType.CAPTIONS &&
    subtype !== chrome.cast.media.TextTrackType.SUBTITLES &&
    subtype !== chrome.cast.media.TextTrackType.DESCRIPTIONS
  ) {
    track.customData = 'side-loaded captions';
    track.language = 'en-US';
  }

  return track;
};

const createMediaTracks = (
  playlistItemTracks: jwplayer.PlaylistItemTrack[]
) => {
  return playlistItemTracks
    .filter(({ kind }) => {
      const subtype = kind?.toUpperCase() as chrome.cast.media.TextTrackType;

      return subtype && subtype in chrome.cast.media.TextTrackType;
    })
    .map(createMediaTrack);
};

export const createMediaInfo = (
  playlistItem: jwplayer.PlaylistItem,
  vmapUrl?: string
) => {
  let { sources } = playlistItem;

  if (playlistItem.allSources) {
    sources = [...playlistItem.allSources].sort((a, b) => {
      return !a.default && b.default ? 1 : 0;
    });
  }

  const source = sources[0];

  if (!source) {
    return null;
  }

  const contentId = createMediaUrl(source.file);
  const contentType = getContentType(source.type);

  const mediaInfo = new chrome.cast.media.MediaInfo(contentId, contentType);

  mediaInfo.metadata = createGenericMediaMetadata(playlistItem);

  mediaInfo.customData = {
    id: playlistItem.id,
  };

  if (playlistItem.tracks?.length) {
    mediaInfo.tracks = createMediaTracks(playlistItem.tracks);
  }

  mediaInfo.textTrackStyle = new chrome.cast.media.TextTrackStyle();

  if (vmapUrl) {
    mediaInfo.vmapAdsRequest = {
      adTagUrl: vmapUrl,
    };
  }

  return mediaInfo;
};
